import "./App.css";
import Header from "./components/Header";
import HeroSlider from "./components/HeroSlider";
import MenuSection from "./components/Menu";
import About from "./components/About";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import FloatingWhatsApp from "./components/FloatingWhatsApp";

function App() {
    return (
        <div className="App font-body" data-testid="app-root">
            <Header />
            <main>
                <HeroSlider />
                <MenuSection />
                <About />
                <Contact />
            </main>
            <Footer />
            <FloatingWhatsApp />
        </div>
    );
}

export default App;
